<template>
  <div class="gf-field">
    <input v-model="componentValue" :type="'text'" :placeholder="placeholder" />
  </div>
</template>

<script>
import { componentMixin } from '../Form/FormCommon'

export default {
  props: ["placeholder", "item", "field"],
  mixins: [componentMixin],
}
</script>
